<template>

    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }" v-if="currentUser != '' && currentUser.role[0] == 'pelapor'">
        <sidenav-router-link icon="ion ion-md-speedometer" to="/app"   :exact="true">Dashboard </sidenav-router-link>


        <sidenav-router-link icon="fad fa-dolly" style="--fa-secondary-opacity: 1.0; --fa-primary-color: var(--c-cyan); --fa-secondary-color: var(--c-purple);" to="/app/laporkan/pesk" :exact="true" v-if="currentUser.user.type == 2">Laporkan Pesk</sidenav-router-link>
        <sidenav-router-link icon="fad fa-dolly" style="--fa-secondary-opacity: 1.0; --fa-primary-color: var(--c-cyan); --fa-secondary-color: var(--c-purple);" to="/app/laporkan/alkes" :exact="true" v-if="currentUser.user.type == 1">Laporkan Alkes</sidenav-router-link>


        <sidenav-router-link icon="ion ion-md-boat" to="/app/penjemputan/pelapor" :exact="true">Penjemputan</sidenav-router-link>
        <sidenav-router-link icon="ion ion-ios-archive" to="/app/riwayat/pelapor" :exact="true">Riwayat</sidenav-router-link>
    </div>
</template>
<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'
export default {
    data: () => ({

    }),
    components:{
        Sidenav,
        SidenavLink,
        SidenavRouterLink,
        SidenavMenu,
        SidenavHeader,
        SidenavBlock,
        SidenavDivider,
    },
    props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },


}
</script>
